import { combineReducers, createStore, applyMiddleware, compose } from 'redux';
import thunk from 'redux-thunk';

import messageReducer from './message';
import postReducer from './post';
import LocationReducer from './location';
import privaGlobalReducer from './privaGlobal';
import followReducer from './follow';
import CategoryReducer from './category';
import CcVerificationReducer from './ccVerification';
import UserReducer from './user';
import StashReducer from './stash';
import ChatGallery from './chatGallery';
import NotesReducers from './notes';
import videoPlayerReducer from './videoPlayer';
import trendingReducer from './trending';
import searchReducer from './search';
import PromotionReducer from './promotions';
import UserListsReducer from './userLists';
import otherUserReducer from './otherUser';

const composeEnhancers = (process.env !== 'production' &&
    typeof window !== 'undefined' &&
    window.__REDUX_DEVTOOLS_EXTENSION_COMPOSE__) ||
    compose;

const store = createStore(
    combineReducers({
        message: messageReducer,
        post: postReducer,
        location: LocationReducer,
        privaGlobal: privaGlobalReducer,
        follow: followReducer,
        category: CategoryReducer,
        ccVerification: CcVerificationReducer,
        user: UserReducer,
        stash: StashReducer,
        notes: NotesReducers,
        chatGallery: ChatGallery,
        videoPlayer: videoPlayerReducer,
        trending: trendingReducer,
        search: searchReducer,
        promotions: PromotionReducer,
        userLists: UserListsReducer,
        otherUser: otherUserReducer,
    }),
    composeEnhancers(applyMiddleware(thunk))
);

export default store;
